import http from "../../http-common"
class NewsArticlesSearchCategoryServices {
    getAllNewsArticlesCategory() {
        return http.get('news-articles-search/category')
    }
}

export default new NewsArticlesSearchCategoryServices();